import type { ReactNode, Ref } from 'react'
import styles from './ScrollView.module.css'

interface ScrollViewProps {
  children?: ReactNode
  maxHeight?: number
  ref?: Ref<HTMLDivElement>
}

/**
 * A scrollable container with an optional maximum height.
 */
export function ScrollView({ children, maxHeight, ref }: ScrollViewProps) {
  const maxHeightStyles = maxHeight ? { maxHeight } : {}

  return (
    <div ref={ref} style={maxHeightStyles} className={styles.root}>
      {children}
    </div>
  )
}
